import { render } from "./LessonDogsTopic1FutureOwner.vue?vue&type=template&id=248420ba"
import script from "./LessonDogsTopic1FutureOwner.vue?vue&type=script&lang=js"
export * from "./LessonDogsTopic1FutureOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__